import { oktaAuth } from "../../components/App";

const api_url = () => {
  if (process.env.REACT_APP_ENV !== "production") {
    //return "http://localhost:7071/api/";
  }
  return "https://gcf-contributor-api-v2.azurewebsites.net/api/";
};

export const getApiURL = () => {
  return api_url();
};

const entra_token = async () => {
  //msal.token.keys.e74cba13-5e83-4945-a069-8ba5d318f6a2
  const localStorageKey = `msal.token.keys.${process.env.REACT_APP_CLIENT_ID}`;
  const tokenData = JSON.parse(localStorage.getItem(localStorageKey) ?? '');
  const accessTokenKey = tokenData &&
    tokenData.accessToken &&
    tokenData.accessToken.length ?
    tokenData.accessToken[0] : null;

  if (!accessTokenKey) {
    localStorage.clear()
    window.location.href = "/"
    return null
  }

  const accessTokenData = JSON.parse(localStorage.getItem(accessTokenKey) ?? '');

  //console.warn({ accessTokenKey, accessTokenData })

  console.log({ accessTokenData })
  return accessTokenData ? `Bearer ${accessTokenData.secret}` : `Bearer null`;
}

// reference: https://developer.okta.com/docs/guides/sign-into-spa-redirect/react/main/#use-the-access-token
const okta_token = async () => {
  const tokenManager = oktaAuth.tokenManager;
  const { accessToken } = await tokenManager.get("accessToken");

  return `Bearer ${accessToken}`;
};

/*const okta_client_id = () => {
    const okta_token_storage = localStorage.getItem('okta-token-storage')
    if (!okta_token_storage || okta_token_storage.length === 0) {
        return null
    }
    return `Bearer ${JSON.parse(okta_token_storage)['idToken']['idToken']}`
}*/

export const getOktaUserGroups = async (id) =>
  fetch(api_url() + `oktaGetUserGroups?id=${id}`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getCycles = async () =>
  fetch(api_url() + `getCycles`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getContributorCycles = async (id) =>
  fetch(api_url() + `getContributorCycles?id=${id}`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getContributor = async (id) =>
  fetch(api_url() + `getContributor?id=${id}`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getContactPhotoURL = (id) => {
  return api_url() + `getContactPhoto?id=${id}`;
};
export const getContactPhoto = async (id) =>
  fetch(api_url() + `getContactPhoto?id=${id}`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => {
      return res.blob();
    })
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getContributorList = async () =>
  fetch(api_url() + "getContributorList", {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getSectionList = async () =>
  fetch(api_url() + "getSectionList", {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getCustomContributorSection = async (contributors, sections) =>
  fetch(api_url() + "getCustomContributorSection", {
    method: "POST",
    headers: {
      Authorization: await entra_token(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ contributors, sections }),
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getCustomContributorData = async (contributors) =>
  fetch(api_url() + "getCustomContributorData", {
    method: "POST",
    headers: {
      Authorization: await entra_token(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ contributors }),
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getContactList = async (id) =>
  fetch(api_url() + `getContactList?id=${id}`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getEntityProjects = async (id) =>
  fetch(api_url() + `getEntityProjects?id=${id}`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getEntityReadinessProjects = async (id) =>
  fetch(api_url() + `getEntityReadinessProjects?id=${id}`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getEntityList = async (id) =>
  fetch(api_url() + `getEntityList?id=${id}`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getContributorSections = async (id) =>
  fetch(api_url() + `getContributorSections?id=${id}`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getContributorSection = async (id, sectionid) =>
  fetch(api_url() + `getContributorSection?id=${id}&sectionid=${sectionid}`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getAuditTrail = async (id) =>
  fetch(api_url() + `getAuditTrail?id=${id}`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getAppLogs = async () =>
  fetch(api_url() + `oktaGetAppLogs`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const setContributorSection = async (section, markdown, user = null) =>
  fetch(api_url() + `setContributorSection`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: await entra_token(),
    },
    body: JSON.stringify({
      id: section.ContributorID,
      sectionid: section.ContributorSectionID,
      markdown,
      user,
    }),
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getSharepointContributorFiles = async (
  ISO3,
  folder,
  confidential = false
) =>
  fetch(
    api_url() +
    `listSharepointFiles?ISO3=${ISO3}&folder=${folder}&cf=${confidential === true ? "true" : "false"
    }`,
    {
      headers: {
        Authorization: await entra_token(),
      },
    }
  )
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

//cycleId = 2454 ==> IRM (default)
export const getContributionStatus = async (id, cycleId = 2454) =>
  fetch(api_url() + `getContributionStatus?id=${id}&cycleId=${cycleId}`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });

export const getSharepointContributorFileList = async (ISO3) =>
  fetch(api_url() + `listSharepointFileList?ISO3=${ISO3}`, {
    headers: {
      Authorization: await entra_token(),
    },
  })
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.error({ err });
      return err;
    });
